import RaphaelSvg from '../vendors/redraphael/source/raphael.svg';
export default {
  extension: function extension(a) {
    RaphaelSvg(a.getDep('redraphael', 'plugin'));
  },
  name: 'redraphaelSvg',
  type: 'plugin',
  requiresFusionCharts: !0
};